module.exports = {
	"data": {
		"markdownRemark": {
			"frontmatter": {
				"title": "FAQ",
				"banner": {
					"imageUrl": "/images/faq/faqbanner.jpg",
					"type": "small",
					"anchor": "center"
				}
			}
		}
	},
	"pathContext": {
		"path": "/faq"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/faq.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/faq.json
// module chunks = 84887730282209